export default __webpack_public_path__ + "static/media/4t.1fd48c57.jpg";